import ActionType from '../schema/ActionType';
import AttachmentFullViewState from '../schema/AttachmentFullViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('addCompletedAction')(function addCompletedAction(
    attachment: AttachmentFullViewState,
    action: ActionType
) {
    attachment.completedActions.push(action);
});
